(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  console.log('[main-collection] v3.0 — variant-cards for v3-5');
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  function updateVariantCards() {
    var cards = document.querySelectorAll('[data-variant-id]');
    console.log('[variant-cards] updateVariantCards() called — found ' + cards.length + ' variant cards');
    cards.forEach(function(card) {
      var productTitle = card.getAttribute('data-variant-product-title');
      var variantLabel = card.getAttribute('data-variant-label');
      var fullTitle = productTitle + ' \u2013 ' + variantLabel;
      var variantUrl = card.getAttribute('data-variant-url');
      var variantPrice = card.getAttribute('data-variant-price');
      var variantComparePrice = card.getAttribute('data-variant-compare-price');
      var variantImage = card.getAttribute('data-variant-image');
      var variantImageSrcset = card.getAttribute('data-variant-image-srcset');
      var variantAvailable = card.getAttribute('data-variant-available');

      // Update all link hrefs
      card.querySelectorAll('a[href]').forEach(function(link) {
        link.setAttribute('href', variantUrl);
      });

      // Update aria-labels
      card.querySelectorAll('[aria-label]').forEach(function(el) {
        el.setAttribute('aria-label', fullTitle);
      });

      // Update hidden accessibility title
      var hiddenTitle = card.querySelector('.product-card__link .visually-hidden');
      if (hiddenTitle) hiddenTitle.textContent = fullTitle;

      // Update product title: keep product name, add variant label as subtitle
      var titleParagraphs = card.querySelectorAll('.product-card__content .text-block p');
      titleParagraphs.forEach(function(titleP) {
        if (titleP.closest('product-price')) return;
        titleP.innerHTML = productTitle +
          '<span class="variant-card-label">' + variantLabel + '</span>';
      });

      // Update zoom-out view title
      var zoomTitle = card.querySelector('.product-grid-view-zoom-out--details h3');
      if (zoomTitle) zoomTitle.textContent = fullTitle;

      // Update image if variant has a specific featured image
      if (variantImage) {
        var img = card.querySelector('.card-gallery img');
        if (img) {
          img.setAttribute('src', variantImage);
          if (variantImageSrcset) img.setAttribute('srcset', variantImageSrcset);
          img.setAttribute('alt', fullTitle);
        }
      }

      // Update price display (v3-5 structure: price__regular / price__sale / price__hidden)
      var priceEl = card.querySelector('product-price');
      if (priceEl && variantPrice) {
        var regularDiv = priceEl.querySelector('.price__regular');
        var saleDiv = priceEl.querySelector('.price__sale');
        if (variantComparePrice && variantAvailable !== 'false') {
          // Show sale price: hide regular, show sale
          if (regularDiv) regularDiv.classList.add('price__hidden');
          if (saleDiv) {
            saleDiv.classList.remove('price__hidden');
            var salePriceSpan = saleDiv.querySelector('.price-item--sale');
            var comparePriceSpan = saleDiv.querySelector('.price-item--regular');
            if (salePriceSpan) salePriceSpan.textContent = variantPrice;
            if (comparePriceSpan) comparePriceSpan.textContent = variantComparePrice;
          }
        } else {
          // Show regular price only
          if (regularDiv) {
            regularDiv.classList.remove('price__hidden');
            var priceSpan = regularDiv.querySelector('.price');
            if (priceSpan) priceSpan.textContent = variantPrice;
          }
          if (saleDiv) saleDiv.classList.add('price__hidden');
        }
      }

      // Update sold-out badge for unavailable variants
      var badgeEl = card.querySelector('.product-badges__badge');
      if (variantAvailable === 'false') {
        if (badgeEl) {
          badgeEl.textContent = badgeEl.closest('[data-sold-out-text]')
            ? badgeEl.closest('[data-sold-out-text]').getAttribute('data-sold-out-text')
            : 'Ausverkauft';
        }
      }

      // Update quick-add button to add the correct variant
      var variantId = card.getAttribute('data-variant-id');
      var quickAdd = card.querySelector('quick-add-component');
      if (quickAdd) {
        var variantInput = quickAdd.querySelector('input[name="id"]');
        if (variantInput) {
          variantInput.value = variantId;
          variantInput.disabled = (variantAvailable === 'false');
        }
        quickAdd.setAttribute('data-quick-add-button', 'add');
      }

    });
  }

  // Fix duplicate view-transition-name: utilities.js sets it based on product-id,
  // but variant cards share that id. This observer catches the style change in real-time
  // and corrects it before the browser processes the view transition.
  var styleObserver = new MutationObserver(function(mutations) {
    mutations.forEach(function(m) {
      var card = m.target;
      if (card.dataset && card.dataset.variantId) {
        var current = card.style.getPropertyValue('view-transition-name');
        var expected = 'product-card-' + card.dataset.variantId;
        if (current && current !== expected) {
          card.style.setProperty('view-transition-name', expected);
        }
      }
    });
  });

  function observeVariantStyles() {
    document.querySelectorAll('[data-variant-id]').forEach(function(card) {
      styleObserver.observe(card, { attributes: true, attributeFilter: ['style'] });
    });
  }

  updateVariantCards();
  observeVariantStyles();

  // Re-run after filter/sort/morph changes.
  var updateTimer = null;
  var isUpdating = false;
  var gridObserver = new MutationObserver(function(mutations) {
    if (isUpdating) return;
    if (updateTimer) clearTimeout(updateTimer);
    updateTimer = setTimeout(function() {
      isUpdating = true;
      updateVariantCards();
      observeVariantStyles();
      setTimeout(function() { isUpdating = false; }, 0);
    }, 100);
  });

  function observeGrid() {
    var resultsList = document.querySelector('results-list');
    if (resultsList) {
      gridObserver.observe(resultsList, { childList: true, subtree: true, attributes: true, attributeFilter: ['data-variant-id', 'data-variant-label', 'data-product-id'] });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observeGrid, { once: true });
  } else {
    observeGrid();
  }

  } catch(e) { console.error(e); }
})();
})();
